import React, { Component } from 'react'
import { CardBox, Page, FormInput } from '../components';
import { connect } from 'react-redux'
import { updatePassword, updateProfile } from '../api';
import { notify } from '../utils';
import { update } from '../actions/auth-actions';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            old_password: '',
            new_password: '',
            new_password_verify: '',
            updating_profile: false,
            updating_password: false,
            user: props.user
        }
    }
    onSubmit(event) {
        if (event) event.preventDefault();
        this.setState({ updating_username: true }, () => {
            updateProfile(
                this.props.user.token,
                { ...this.state.user }
            ).then((user) => {
                this.setState({ updating_username: false })
                this.props.success(user)
            }).catch((error) => {
                this.setState({ updating_username: false }, () => {
                    notify('Error', error.message, 'error')
                });
            })
        })
    }
    onSubmitPassword(event) {
        if (event) event.preventDefault();
        this.setState({ updating_password: true }, () => {
            let { old_password, new_password, new_password_verify } = this.state;
            if (
                old_password.length === 0 ||
                new_password.length === 0 ||
                new_password_verify.length === 0
            ) return;
            updatePassword(
                this.props.user.token,
                { old_password, new_password, new_password_verify }
            ).then((user) => {
                this.setState({ updating_password: false })
            }).catch((error) => {
                this.setState({ updating_password: false }, () => {
                    notify('Error', error.message, 'error')
                });
            })
        })
    }
    render() {
        return (
            <Page title="Profile">
                <CardBox>
                    <form onSubmit={this.onSubmit.bind(this)}>
                        <div>
                            <h4>CHANGE USERNAME:</h4>
                            <FormInput
                                value={this.state.user.username}
                                onChange={(username) => {
                                    let { user } = this.state;
                                    user.username = username;
                                    this.setState({ user });
                                }}
                                placeholder="New Username" />
                        </div>
                    </form>
                </CardBox>
                <div className="text-center" style={{ marginBottom: '24px' }}>
                    <button onClick={this.onSubmit.bind(this)} className="btn btn-info">
                        {!this.state.updating_username && 'UPDATE USERNAME'}
                        {this.state.updating_username && 'UPDATING...'}
                    </button>
                </div>
                <CardBox>
                    <form onSubmit={this.onSubmitPassword.bind(this)}>
                        <div>
                            <h4>CHANGE PASSWORD:</h4>
                            <FormInput
                                value={this.state.old_password}
                                onChange={(old_password) => {
                                    this.setState({ old_password });
                                }}
                                type="password"
                                placeholder="Current password" />
                            <FormInput
                                value={this.state.new_password}
                                onChange={(new_password) => {
                                    this.setState({ new_password });
                                }}
                                type="password"
                                placeholder="New password" />
                            <FormInput
                                value={this.state.new_password_verify}
                                onChange={(new_password_verify) => {
                                    this.setState({ new_password_verify });
                                }}
                                type="password"
                                placeholder="Confirm new password" />
                        </div>
                    </form>
                </CardBox>
                <div className="text-center">
                    <button onClick={this.onSubmitPassword.bind(this)} className="btn btn-info">
                        {!this.state.updating_password && 'UPDATE PASSWORD'}
                        {this.state.updating_password && 'UPDATING...'}
                    </button>
                </div>
            </Page>
        )
    }
}

const mapStateToProps = state => ({
    user: state.authReducer.user
});

const mapDispatchToProps = dispatch => ({
    success(user) {
        dispatch(update(user))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);


// WEBPACK FOOTER //
// ./src/routers/Profile.js